import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

const isRemoveElementsAllowed = (state: RootState) => {
  if (!isEmbedded) {
    return state.hostSettings.allowRemoveElements;
  }

  const personalizationSettings = state.design?.designData?.personalizationSettings;

  // allowAddElements is a compatibility leg, not the intended semantics: until this
  // read was fixed, removal was gated on it alone, so products that only ticked
  // "Add layers" have been shipping a working delete control. Dropping the leg would
  // silently take that away from them — it needs a migration, not a flip here.
  return !!(personalizationSettings?.allowRemoveElements || personalizationSettings?.allowAddElements);
};

export default isRemoveElementsAllowed;
